import { App as AntApp, ConfigProvider } from 'antd';
import { Suspense, useLayoutEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router';
import ProtectedRoute from './components/ProtectedRoute';
import useAppBoot from './hooks/useAppBoot';
import Loader from './pages/Loader';
import { PUBLIC_ROUTES } from './routes';
import { antdThemeLight } from './theme/theme';

// Every page opens at its top. The home page then scrolls to a requested
// section itself (see useSectionScrollOnArrival).
const useScrollToTopOnNavigate = () => {
  const { pathname } = useLocation();
  useLayoutEffect(() => {
    window.scrollTo({ top: 0 });
  }, [pathname]);
};

const App = () => {
  const { isAppLoading } = useAppBoot();
  useScrollToTopOnNavigate();
  return (
    <ConfigProvider theme={antdThemeLight}>
      <AntApp>
        {isAppLoading ? (
          <Loader />
        ) : (
          <Routes>
            {/* Public routers */}
            {PUBLIC_ROUTES.map(
              ({ path, element: Element, protected: isProtected }, idx) => (
                <Route
                  path={path}
                  key={idx + path}
                  element={
                    <Suspense fallback={<Loader />}>
                      {isProtected ? (
                        <ProtectedRoute>
                          <Element />
                        </ProtectedRoute>
                      ) : (
                        <Element />
                      )}
                    </Suspense>
                  }
                />
              ),
            )}
          </Routes>
        )}
      </AntApp>
    </ConfigProvider>
  );
};

export default App;
